// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__I_6gN","colBig":"styles_colBig__2wUdN","colSmall":"styles_colSmall__2nzFk"};